import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthenticated } from '../hooks/useAuthenticated';

interface AuthRouteProps {
  element: React.ReactElement;
  requirePlan?: boolean;
  forAdmin?: boolean;
}

const AuthRoute: React.FC<AuthRouteProps> = ({
  element,
  requirePlan = false,
  forAdmin = false,
}) => {
  const { isAuthenticated, isAdmin, isPlanActive, loading } =
    useAuthenticated();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (forAdmin && !isAdmin) {
    return <Navigate to="/dashboard" state={{ from: location }} replace />;
  }

  if (!forAdmin && isAdmin) {
    return <Navigate to="/admin" state={{ from: location }} replace />;
  }

  if (requirePlan && !isPlanActive) {
    return <Navigate to="/pricing" state={{ from: location }} replace />;
  }

  return element;
};

export default AuthRoute;
